/*jshint latedef: nofunc */
const Handlebars = require('../../node_modules/handlebars/dist/handlebars.min.js');
(($) => {
  document.addEventListener('DOMContentLoaded', () => {
    const FWP = window.FWP || {};
    const FWP_MAP = window.FWP_MAP || {};
    const google = window.google || {};
    const markerSlotDiv = document.getElementById('markerSlot'); // Getting the div who will contain the popup

    const poiTemplate = document.getElementById('tmpl-marker-poi').innerHTML; // Getting the div who will contain the popup and the template
    const popupPoiTemplate = Handlebars.compile(poiTemplate); // Compiling the template

    const markerContainer = document.getElementById('map-marker');

    /* Force the FacteWP category filter checkbox to select only one at the same time (like the radio) */
    let clickedSlug;
    let activeFilter;

    /**
     * Get lasted selected facet
     */
    function getLastedSelectedFacet() {
      $('.facetwp-type-checkboxes .facetwp-checkbox').on('click', (event) => {
        const eventClickedSlug = event.target
          .closest('.facetwp-checkbox')
          .getAttribute('data-value');
        if (clickedSlug !== eventClickedSlug) {
          clickedSlug = eventClickedSlug;
        }
        activeFilter = event.target
          .closest('.facetwp-facet')
          .getAttribute('data-name');
      });

      $('.facetwp-type-autocomplete').on('click', (event) => {
        activeFilter = event.target
          .closest('.facetwp-type-autocomplete')
          .getAttribute('data-name');
      });
    }
    /**
     * Get marker info into common window
     *
     * @param {Element} $currentMarker
     */

    function displaySelectedMarkerInfo(currentMarker) {
      /* Exit this function if not on main interactive map */
      if (null === markerContainer) {
        return;
      }
      const templateData = currentMarker.postdata;

      templateData.totalPosts = FWP_MAP.mapArray.length;
      templateData.previousPost =
        FWP_MAP.mapArray[FWP_MAP.mapArray.indexOf(currentMarker) - 1] || null;
      templateData.nextPost =
        FWP_MAP.mapArray[FWP_MAP.mapArray.indexOf(currentMarker) + 1] || null;
      templateData.indexValue = FWP_MAP.mapArray.indexOf(currentMarker) + 1;
      templateData.divClass = 'item'; // content with class bubble because it will displayed as side popup

      //Setting the template with the values inside the DIV
      markerSlotDiv.innerHTML = popupPoiTemplate(templateData);

      document.querySelector('.map-marker__item').classList.add('visible');

      changeSelectedMarker();

      if (!markerContainer.classList.contains('opened')) {
        markerContainer.classList.add('opened');
      }

      markerSlotDiv.classList.add('visible');
      markerSlotDiv.focus();
    }

    /**
     * If only one area is displayed, fill the background
     */
    function fillLonelyArea() {
      if ('undefined' !== typeof FWP_MAP.mapArray) {
        /* Area only (Area = 1 and Hidden Marker for this area = 1 ) */
        if (1 === FWP_MAP.shapesArray.length && 1 === FWP_MAP.mapArray.length) {
          const currentItem = FWP_MAP.shapesArray[0];
          currentItem.setOptions({ fillOpacity: 0.2 });
          google.maps.event.trigger(currentItem, 'click');
        }

        /* Marker only (Area = 0 and Marker = 1 ) */
        if (0 === FWP_MAP.shapesArray.length && 1 === FWP_MAP.mapArray.length) {
          const currentItem = FWP_MAP.mapArray[0];
          if (currentItem.isCurrentPositionMarker) {
            return;
          }
          google.maps.event.trigger(currentItem, 'spider_click');
        }

        /* if FWP.currentLocationMarker */

        if (null !== FWP_MAP.curPosition) {
          FWP_MAP.markersArray.forEach((marker) => {
            if (
              marker.position.lat() === FWP_MAP.curPosition.lat() &&
              marker.position.lng() === FWP_MAP.curPosition.lng()
            ) {
            }
          });
        }
      }
    }

    // Auto click on the polygon who contain a specific marker
    function openParentPolygon(marker = null) {
      if (marker === null && null !== FWP_MAP.curPosition) {
        marker = FWP_MAP.curPosition;
      }

      if (marker !== null) {
        $.each(FWP_MAP.shapesArray, (index, currentShape) => {
          if (
            true ===
            google.maps.geometry.poly.containsLocation(marker, currentShape)
          ) {
            google.maps.event.trigger(currentShape, 'click');
          }
        });
      }
    }

    /**
     * Keep only the last selected facet and only one filter active at the same time
     */
    function keepOnlyOneActiveFacetAndFilter() {
      if (
        FWP.facets.poi_categories.length > 0 &&
        activeFilter === 'poi_categories'
      ) {
        FWP.facets.poi_categories = [clickedSlug];
        FWP.facets.poi_search = [];
      }

      if (FWP.facets.poi_search.length > 0 && activeFilter === 'poi_search') {
        FWP.facets.poi_categories = [];
      }

      /* if both empty */
      if (
        FWP.facets.poi_categories.length === 0 &&
        FWP.facets.poi_search.length === 0
      ) {
        FWP.facets.poi_categories = [];
      }
    }

    /**
     * Close marker info
     */
    function closeMarkerInfo() {
      if (document.querySelector('.map-marker__close')) {
        document
          .querySelector('.map-marker__close')
          .addEventListener('click', () => {
            const filtersSidebar = document.querySelector(
              '.complete-map__sidebar'
            );
            markerContainer.classList.remove('opened');
            filtersSidebar.focus();
          });
      }
    }

    function changeSelectedMarker() {
      const changeBtns = document.querySelectorAll('.displayPopupById');

      if (0 < changeBtns.length) {
        changeBtns.forEach((changeBtn) => {
          changeBtn.addEventListener('click', (event) => {
            /* get event data attribute post-id */
            const postId = event.target
              .closest('.displayPopupById')
              .getAttribute('data-post-id');

            if (null !== postId) {
              FWP_MAP.mapArray.forEach((currentMarker) => {
                if (currentMarker.postdata.ID === parseInt(postId)) {
                  displaySelectedMarkerInfo(currentMarker);
                }
              });
            }
          });
        });
      }
    }

    /*
     * for accessibility
     * click on checkbox when using keyboard
     */
    function simulateCheckboxClick() {
      const checkboxes = document.querySelectorAll('.facetwp-checkbox');

      if (0 < checkboxes.length) {
        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('keydown', (e) => {
            if ('Enter' === e.code) {
              checkbox.click();
            }
          });
        });
      }
    }

    $(document).on('facetwp-refresh', function () {
      keepOnlyOneActiveFacetAndFilter();
    });

    $(document).on('facetwp-loaded', () => {
      getLastedSelectedFacet();
      fillLonelyArea();
      openParentPolygon();
      closeMarkerInfo();
      simulateCheckboxClick();

      FWP.resetAutocomplete = () => {
        document.querySelector('input.facetwp-autocomplete').value = '';
        if (FWP.facets.poi_search.length > 0) {
          FWP.facets.poi_search = [];
          FWP.refresh();
        }
      };

      /* Marker, polygon and polyline click actions */
      FWP.hooks.addAction('facetwp_vtx_map/marker/click', (marker) => {
        if (!marker.isCurrentPositionMarker) {
          displaySelectedMarkerInfo(marker);
        }
      });

      FWP.hooks.addAction('facetwp_vtx_map/polygon/click', (shape) => {
        displaySelectedMarkerInfo(shape);

        /* Set background */
        $.each(FWP_MAP.shapesArray, (index, polygon) => {
          polygon.setOptions(FWP_MAP.default_args_polygon);
        });
        shape.setOptions({ isSelected: true });
        shape.setOptions({ fillOpacity: shape.fillOpacity * 2 });
      });
      FWP.hooks.addAction('facetwp_vtx_map/polyline/click', (polyline) => {
        displaySelectedMarkerInfo(polyline);
      });

      /* Polygon mouseover actions */
      FWP.hooks.addAction('facetwp_vtx_map/polygon/mouseover', (polygon) => {
        if (!polygon.isSelected) {
          polygon.setOptions({ fillOpacity: polygon.fillOpacity * 2 });
          polygon.setOptions({ zIndex: 1 });
        }
      });
      FWP.hooks.addAction('facetwp_vtx_map/polygon/mouseout', (polygon) => {
        if (!polygon.isSelected) {
          polygon.setOptions({ fillOpacity: polygon.fillOpacity / 2 });
          polygon.setOptions({ zIndex: 1 });
        }
      });

      /* Polylines mouseover actions */
      FWP.hooks.addAction('facetwp_vtx_map/polyline/mouseover', (polyline) => {
        polyline.setOptions({ originalStrokeColor: polyline.strokeColor }); //saving original color
        polyline.setOptions({ strokeColor: polyline.hoverStrokeColor }); // setting hover color
      });
      FWP.hooks.addAction('facetwp_vtx_map/polyline/mouseout', (polyline) => {
        polyline.setOptions({ strokeColor: polyline.originalStrokeColor }); // setting original color
      });
    });

    //toogle button filter mp
    $('#filter-toggle').click(() => {
      $('.complete-map__sidebar').toggleClass('show-mobile');
    });
  });
})(jQuery);
